import axios from 'axios';
import swal from "sweetalert2";
import barramento from '../barramento';

export default class DanfeA4Simplified {

  static async printDanfA4Simplificada(obj, porItem = false, expedition = 'todos') {
    if (porItem) this.forOrders(obj, expedition);
    else this.forOrder(obj, expedition);
  }

  static async axiosPost(obj, get_labels = null, expedition = 'todos') {
    barramento.$emit(`orders_load_nav_bar_${expedition}`, true);
    barramento.$emit(`expedition_menu_dropdown_spinner_${expedition}`, true);
    barramento.$emit(`alert_spinner_${expedition}`, true);
    barramento.$emit('orders_load_nav_bar2', true);
    axios({
      method: "POST",
      url: get_labels ? '/api/documents/get_labels' : "/api/orders/mergePdfs",
      data: obj,
      headers: { "content-type": "application/json" }
    }).then(response => {
      let link = document.createElement("a");
      link.setAttribute("href", response.data.file);
      link.setAttribute("download", response.data.file);
      link.setAttribute("target", "_blank");
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      barramento.$emit(`orders_load_nav_bar_${expedition}`, false);
      barramento.$emit(`expedition_menu_dropdown_spinner_${expedition}`, false);
      barramento.$emit(`alert_spinner_${expedition}`, false);
      barramento.$emit('orders_load_nav_bar2', false);
      return true;
    }, error => {
      swal({
        title: "Ops!",
        text: "Não foi possível gerar os arquivos",
        type: "error",
      });
      barramento.$emit(`orders_load_nav_bar_${expedition}`, false);
      barramento.$emit(`expedition_menu_dropdown_spinner_${expedition}`, false);
      barramento.$emit(`alert_spinner_${expedition}`, false);
      barramento.$emit('orders_load_nav_bar2', false);
      return false;
    });
  }

  static async forOrder(order, expedition) {
    var obj = [];
    for (var i = 0; i < order.shipments.length; i++) {
      for (var j = 0; j < order.shipments[i].documents.length; j++) {
        if (order.shipments[i].documents[j] && (order.shipments[i].documents[j].type === "invoice" || order.shipments[i].documents[j].type === "label" || order.shipments[i].documents[j].type == "invoice_label")) {
          obj.push({
            id: order.id,
            url: order.shipments[i].documents[j].url,
            type: order.shipments[i].documents[j].type,
          });
        }
      }
    }

    if (!obj.length) {
      barramento.$emit(`orders_load_nav_bar_${expedition}`, false);
      barramento.$emit('orders_load_nav_bar2', false);
      swal({
        title: 'Ops!',
        text: 'Sem etiqueta para realizar impressão!',
        type: "warning",
      });
      return;
    } else {
      obj.forEach(item => {
        this.axiosPost([item], null, expedition);
      });
    }
  }

  static async forOrders(orders, expedition) {
    var obj = [];
    for (var x = 0; x < orders.length; x++) {
      for (var i = 0; i < orders[x].shipments.length; i++) {
        var shipments = orders[x].shipments;
        for (var j = 0; j < shipments[i].documents.length; j++) {
          if (shipments[i].documents[j] && (shipments[i].documents[j].type === "invoice" || shipments[i].documents[j].type === "label" || shipments[i].documents[j].type == "invoice_label")) {
            obj.push({
              id: orders[x].id,
              url: shipments[i].documents[j].url,
              type: shipments[i].documents[j].type,
            });
          }
        }
      }
    }

    if (!obj.length) {
      barramento.$emit(`orders_load_nav_bar_${expedition}`, false);
      barramento.$emit(`expedition_menu_dropdown_spinner_${expedition}`, false);
      barramento.$emit('orders_load_nav_bar2', false);
      swal({
        title: 'Ops!',
        text: 'Sem etiqueta para realizar impressão!',
        type: "warning",
      });
      return;
    } else
      this.axiosPost(obj, null, expedition);
  }

  static async forEtiqueta(orders, expedition) {
    var obj = [];
    for (var x in orders) {
      for (var i in orders[x].shipments) {
        var shipments = orders[x].shipments;

        for (var j in shipments[i].documents) {
          if (shipments[i].documents[j] && shipments[i].documents[j].type === "label") {

            var r = null;
            r = obj.find((fruit) => fruit.id === orders[x].id);

            if (!r) {
              obj.push({
                id: orders[x].id,
                url: shipments[i].documents[j].url,
                type: shipments[i].documents[j].type,
              });
            }
          }
        }
      }
    }

    if (!obj.length) {
      barramento.$emit(`orders_load_nav_bar_${expedition}`, false);
      barramento.$emit(`expedition_menu_dropdown_spinner_${expedition}`, false);
      barramento.$emit('orders_load_nav_bar2', false);
      swal({
        title: 'Ops!',
        text: 'Sem etiqueta para realizar impressão.',
        type: "warning",
      });
      return;
    } else
      this.axiosPost(obj, 'get_labels', expedition);
  }

  static async jetScanFiscal(obj) { // Impressão automática para impressoras de nota fiscal.
    axios({
      method: "POST",
      url: "/api/orders/mergePdfs",
      data: obj,
      headers: { "content-type": "application/json" }
    }).then(response => {

      let link = document.createElement("a");
      link.setAttribute("href", response.data.file);
      link.setAttribute("download", response.data.file);
      link.setAttribute("target", "_blank");
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return true;
    }, error => {
      swal({
        title: "Ops!",
        text: "Não foi possível gerar os arquivos",
        type: "error",
      });
      return false;
    });
  }

  /*
 * Removes iframe from the DOM
 */
  static async closePrint() {
    document.body.removeChild(this.__container__);
  }

  /*
   * Sets print functionality
   */
  static async setPrint() {
    window.__container__ = this;
    window.onbeforeunload = this.closePrint();
    window.onafterprint = this.closePrint();
    window.focus(); // Required for IE

    var result = window.document.execCommand('print', true, null);
    if (!result) {
      window.print();
    }
  }

  /*
   * Prints an external url
   * @param {string} sURL url
   */
  static async printPage(sURL) {
    var oHiddFrame = document.createElement("iframe");
    oHiddFrame.onload = this.setPrint();
    oHiddFrame.style.visibility = "visible";
    oHiddFrame.style.position = "fixed";
    oHiddFrame.style.right = "0";
    oHiddFrame.style.bottom = "0";
    oHiddFrame.style.height = "0";
    oHiddFrame.style.width = "0";
    oHiddFrame.src = sURL;
    document.body.appendChild(oHiddFrame);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/util/danfeA4Simplified.js